import React, {Dispatch, FC, SetStateAction} from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import {AppEmojis, AppIds, AppNames, Apps, GenderName, Genders} from 'enums';
import {
    AbuseWord,
    ActionTypes,
    ActionTypesLabels,
    PatternTypes,
    PatternTypesLabels
} from 'services/abuseWordsService';
import {AbuseWordModalFormSection} from 'pages/AbuseWords/components/AbuseWordModalFormSection';

type Props = {
    word: AbuseWord;
    setWord: Dispatch<SetStateAction<AbuseWord>>;
    app: Apps;
    appIdsSupported: boolean;
};

export const AbuseWordModalRuleSection: FC<Props> = ({word, setWord, app, appIdsSupported}) => (
    <div className="border rounded-3 p-3 p-lg-4 bg-white shadow-sm">
        <AbuseWordModalFormSection
            label="Название"
            controlId="abuse-word-rule-name"
            description={<>Формат: <span className="fst-italic">Тег: Название (Язык)</span></>}
        >
            <Form.Control type="text" placeholder="Тег: Название (Язык)"
                          value={word.ruleName}
                          onChange={e => setWord(w => ({...w, ruleName: e.target.value}))}/>
        </AbuseWordModalFormSection>

        {appIdsSupported && <AbuseWordModalFormSection label="Приложения">
            <div className="d-flex flex-wrap gap-3">
                {Object.values(AppIds).filter((v): v is AppIds => typeof v === 'number').map(appId => {
                    const aid = `abuse-app-${appId}`;
                    return (
                        <div key={appId} className="form-check">
                            <input className="form-check-input"
                                   type="checkbox"
                                   id={aid}
                                   checked={word.appIds?.includes(appId) ?? false}
                                   onChange={() => setWord(prev => prev.appIds?.includes(appId) ? {
                                       ...prev,
                                       appIds: prev.appIds?.filter(a => a !== appId)
                                   } : {...prev, appIds: [...(prev.appIds ?? []), appId]})}/>
                            <label className="form-check-label" htmlFor={aid}>
                                {AppEmojis[appId]} {AppNames[appId]}
                            </label>
                        </div>
                    );
                })}
            </div>
        </AbuseWordModalFormSection>}

        <AbuseWordModalFormSection label="Тип проверки">
            <Row className="g-2">
                {Object.values(PatternTypes).filter(v => typeof (v) === 'number').map((v) => {
                    const pt = v as PatternTypes;
                    const id = `abuse-pattern-${pt}`;
                    return (
                        <Col xs={6} key={pt}>
                            <div className="form-check">
                                <input className="form-check-input"
                                       type="checkbox"
                                       id={id}
                                       checked={word.patternTypes?.includes(pt)}
                                       onChange={() => setWord(prev => prev.patternTypes?.includes(pt) ? {
                                           ...prev,
                                           patternTypes: prev.patternTypes?.filter(g => g !== pt) ?? []
                                       } : {...prev, patternTypes: [...(prev.patternTypes ?? []), pt]})}/>
                                <label className="form-check-label" htmlFor={id}>
                                    {PatternTypesLabels[pt]}
                                </label>
                            </div>
                        </Col>
                    );
                })}
            </Row>
        </AbuseWordModalFormSection>

        <AbuseWordModalFormSection label="Гендер">
            <div className="d-flex flex-wrap gap-3">
                {Object.values(Genders).map(gender => {
                    const gid = `abuse-gender-${gender}`;
                    return (
                        <div key={gender} className="form-check">
                            <input className="form-check-input"
                                   type="checkbox"
                                   id={gid}
                                   checked={word.genders.includes(gender)}
                                   onChange={() => setWord(prev => prev.genders.includes(gender) ? {
                                       ...prev,
                                       genders: prev.genders.filter(g => g !== gender)
                                   } : {...prev, genders: [...prev.genders, gender]})}/>
                            <label className="form-check-label" htmlFor={gid}>
                                {GenderName[gender]}
                            </label>
                        </div>
                    );
                })}
            </div>
        </AbuseWordModalFormSection>

        <AbuseWordModalFormSection label="Действие при срабатывании" controlId="abuse-word-action" last>
            <Form.Select value={word.actionType} onChange={e => {
                setWord(w => ({...w, actionType: (+e.target.value)}))
            }}>
                {Object.values(ActionTypes).filter(v => typeof (v) === 'number').map(v =>
                    <option value={v} key={v}>{ActionTypesLabels(app)[+v as ActionTypes]}</option>)}
            </Form.Select>
        </AbuseWordModalFormSection>
    </div>
);
